import AemInlineNotification from '@/components/Aem/AemInlineNotification';
import {OtpTypeCode} from '@/consts/loginTypes';
import appContent from '@/services/content/appContent.typed';
import type {InlineNotificationModel} from '@/types/aem/inlineNotificationModel';

import type {OtpIdentifierSubmitParams} from '../../hooks/useOtpLoginHandlers';
import type {LoginErrorDetails} from '../../LoginPageV2.types';
import LoginHeader from '../LoginHeader';
import OtpChannelTabs from './OtpChannelTabs';
import OtpIdentifierForm from './OtpIdentifierForm';

interface OtpIdentifierSectionProps {
    channel: OtpTypeCode;
    channels: OtpTypeCode[];
    hasTabs: boolean;
    onChannelChange: (channel: OtpTypeCode) => void;
    onSubmit: (data: OtpIdentifierSubmitParams) => void;
    error?: LoginErrorDetails;
    setError?: (isError: LoginErrorDetails) => void;
    isLoginLanguageSelectEnabled?: boolean;
}

const OtpIdentifierSection = ({
    isLoginLanguageSelectEnabled,
    channel,
    channels,
    hasTabs,
    onChannelChange,
    onSubmit,
    error,
    setError,
}: OtpIdentifierSectionProps) => {
    const {title} = appContent.getOtpContent();
    const err = error as InlineNotificationModel | null;

    return (
        <>
            <LoginHeader title={title} isLanguageSelectEnabled={isLoginLanguageSelectEnabled} />
            <OtpChannelTabs
                className='w-full'
                activeChannel={channel}
                channels={channels}
                hasTabs={hasTabs}
                onChannelChange={onChannelChange}
            >
                {err && <AemInlineNotification aria-live='assertive' className='my-8' model={err} />}
                <OtpIdentifierForm
                    error={error}
                    setError={setError}
                    key={channel}
                    channel={channel}
                    onSubmit={onSubmit}
                />
            </OtpChannelTabs>
        </>
    );
};

export default OtpIdentifierSection;
